import { z } from 'zod';

/**
 * The `?q=` free-text filter shared by every visible-scope list endpoint
 * (IMM-448.4). Optional, trimmed, and blank-as-absent: `?q=` and `?q=%20` both
 * normalise to `undefined`, which the list handlers treat as "no search" and
 * return the full (scope-restricted) list unchanged.
 *
 * One schema rather than one per module on purpose — five list endpoints
 * behaving identically is worth more than any per-endpoint refinement, and the
 * shipped Kontakte list is the precedent every other list now follows.
 *
 * What the term MATCHES is the individual module's business: each list endpoint
 * runs the very predicate its ⌘K `SearchSource` runs, so the palette's
 * „5 von 12" and the list it jumps to can never disagree.
 */
export const ListSearchTermSchema = z
  .string()
  .optional()
  .transform((value) => {
    const trimmed = value?.trim();

    return trimmed === undefined || trimmed === '' ? undefined : trimmed;
  });
